import { motion } from "framer-motion";
import { UserPlus, MapPin, QrCode, Droplets, DollarSign } from "lucide-react";

const steps = [
  { icon: UserPlus, title: "Customer Signs Up", desc: "A member joins the AnyWash Pass network and gets access to all partner locations." },
  { icon: MapPin, title: "Visits Your Location", desc: "The customer drives to your car wash — no appointment needed." },
  { icon: QrCode, title: "Scans QR Code", desc: "They scan the QR code posted at your location to check in instantly." },
  { icon: Droplets, title: "You Select Wash Type", desc: "Choose the wash level — Basic, Mid-Tier, or Premium — and start washing." },
  { icon: DollarSign, title: "You Get Paid Weekly", desc: "We pay you directly every week. No chasing payments, no invoicing." },
];

const container = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export default function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-24 sm:py-32 px-6 sm:px-12 lg:px-24 bg-[#0d0d0d]"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500 mb-4 block">
            Simple Process
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
            How It Works
          </h2>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6"
        >
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={i}
                variants={item}
                data-testid={`step-card-${i + 1}`}
                className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8 hover:border-neutral-700 transition-colors duration-300 text-center relative"
              >
                <div className="absolute top-4 right-4 text-neutral-700 text-xs font-bold">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="w-12 h-12 rounded-full bg-blue-600/10 border border-blue-500/20 flex items-center justify-center mx-auto mb-5">
                  <Icon className="w-5 h-5 text-blue-500" />
                </div>
                <h3 className="text-white font-bold text-lg mb-3">{step.title}</h3>
                <p className="text-neutral-500 text-sm leading-relaxed">{step.desc}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
